import { makeStyles } from '@material-ui/core/styles'

const useMainDashboardStyles = makeStyles(_ => ({
   root: {
      display: 'flex',
      height: '100%'
   },
   content: {
      flex: '1 1 auto'
   }
}))

export default useMainDashboardStyles
